import get from 'lodash/fp/get'
import * as Elasticsearch from '../../../elasticsearch'
import * as Counters from '../counters'
import * as Utils from '../utils'
import * as Types from './types'

const toOtherClick = (bucket: any): Types.OtherClick => {

  const totalClickCounter: Types.UniqueCounter = Counters.newCounterEntry(bucket)

  const suspectClickBuckets = get(Elasticsearch.DocumentFieldNames.SuspectClick, bucket)

  const suspectClickBucket = Utils.firstBucketEntry(suspectClickBuckets, 1)
  const suspectClickCounter: Types.UniqueCounter = suspectClickBucket ?
    Counters.newCounterEntry(suspectClickBucket) : {}

  const realClickBucket = Utils.firstBucketEntry(suspectClickBuckets, 0)
  const realClickCounter: Types.UniqueCounter = realClickBucket ?
    Counters.newCounterEntry(realClickBucket) : totalClickCounter

  return {
    realClick: realClickCounter,
    suspectClick: suspectClickCounter,
    totalClick: totalClickCounter,
    url: get('key', bucket),
  }
}

export const getOtherClicks = (payload: any): Types.OtherClick[] => {
  return get('aggregations.clicked_url.buckets', payload).map((bucket: any) => toOtherClick(bucket))
}



// WEBPACK FOOTER //
// ./src/pages/reports/other-clicks/utils.ts